import {Dispatch, FC, SetStateAction} from 'react'
import {useQuery} from 'react-query'
import {Invoice} from '../../core/_models'
import {
  getInvoicePaymentOptions,
  startInvoicePayment,
} from '../../../../../online-payment/core/onlinePaymentApi'
import {OnlinePaymentForm} from '../../../../../online-payment/components/OnlinePaymentDialog'

type Props = {
  invoice: Invoice
  setShowPaymentModal: Dispatch<SetStateAction<boolean>>
}

/**
 * «پرداخت آنلاین» of the classic print page: the business's gateways from its online payment settings (any
 * provider it configured, the old Saman terminal included), the same form and rules as the new print page.
 * After the gateway the payer comes back to this page.
 */
const PaymentOnline: FC<Props> = ({invoice, setShowPaymentModal}) => {
  const hash = invoice.hsh || ''
  const options = useQuery(['online-payment-options', hash], () => getInvoicePaymentOptions(hash), {
    enabled: hash.length > 0,
    retry: false,
    refetchOnWindowFocus: false,
  })

  if (options.isLoading) {
    return (
      <div className='card-body d-flex align-items-center gap-3 text-muted' role='status'>
        <span className='spinner-border spinner-border-sm' aria-hidden='true' />
        در حال دریافت درگاه‌های پرداخت…
      </div>
    )
  }

  if (!options.data?.enabled) {
    return (
      <div className='card-body'>
        <div className='alert alert-light-warning mb-0' role='status'>
          {options.data?.reason || 'پرداخت آنلاین برای این صورتحساب در دسترس نیست.'}
        </div>
      </div>
    )
  }

  return (
    <div className='card-body'>
      <OnlinePaymentForm
        options={options.data}
        start={(input) => startInvoicePayment(hash, {...input, page: 'classic'})}
        onCancel={() => setShowPaymentModal(false)}
      />
    </div>
  )
}

export {PaymentOnline}
